var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_201_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2420_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_563_",
    d: "M13,26C5.8,26,0,20.2,0,13S5.8,0,13,0s13,5.8,13,13S20.2,26,13,26z M13,1.6C6.7,1.6,1.6,6.7,1.6,13 S6.7,24.4,13,24.4S24.4,19.3,24.4,13S19.3,1.6,13,1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2133_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_359_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1224_",
    d: "M12.7,19l-7.8-7.7c-0.2-0.2-0.2-0.4,0-0.6l0.6-0.6c0.2-0.2,0.4-0.2,0.6,0L13,17l6.9-6.9 c0.2-0.2,0.4-0.2,0.6,0l0.6,0.6c0.2,0.2,0.2,0.4,0,0.6L13.3,19C13.1,19.2,12.9,19.2,12.7,19z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.38633c7b1b0ffa606c7ce7873c5b27c2.svg";
export { ForwardRef as ReactComponent };